import axios from "axios";
import { API_URL, FOLDERPATH } from "../Constants/config";
import { toast } from "react-toastify";
import {
  CREDIT_CIBIL_LOADING,
  CREDIT_CIBIL_SUCCESS,
  CREDIT_CIBIL_FAILED,
  SEND_OTP_CIBIL_LOADING,
  SEND_OTP_CIBIL_SUCCESS,
  SEND_OTP_CIBIL_FAILED,
  VALIDATE_OTP_LOADING,
  VALIDATE_OTP_SUCCESS,
  VALIDATE_OTP_FAILED,
  SAVE_CIBIL_LOADING,
  SAVE_CIBIL_SUCCESS,
  SAVE_CIBIL_FAILED,
  SAVE_ALTERNATE_MOBILE_LOADING,
  SAVE_ALTERNATE_MOBILE_SUCCESS,
  SAVE_ALTERNATE_MOBILE_FAILED,
  SAVE_SKIP_LOADING,
  SAVE_SKIP_SUCCESS,
  SAVE_SKIP_FAILED,
  VERIFY_ANSWERS_LOADING,
  VERIFY_ANSWERS_SUCCESS,
  VERIFY_ANSWERS_FAILED,
} from "../Constants/creditCibilHistoryConstants";

import { handleApiError } from "../Helper/actionHelper";

export const creditCibilHistory = () => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

    dispatch({ type: CREDIT_CIBIL_LOADING });

    const requestData = {
      token: userLocalData.id,
    };

    //return false;
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(
      FOLDERPATH + "/CandidateApi/creditHistory",
      requestData,
      {
        headers: headers,
      }
    );

    dispatch({
      type: CREDIT_CIBIL_SUCCESS,
      payload: data,
    });

    handleApiError(data);
    const msg = data.message;

    toast.error(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  } catch (error) {
    dispatch({
      type: CREDIT_CIBIL_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const sendOTPCibilHistory = (record) => async (dispatch) => {
  try {
    dispatch({ type: SEND_OTP_CIBIL_LOADING });

    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

    const requestData = {
      token: userLocalData.id,
      ...record,
    };
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data: result } = await axios.post(
      FOLDERPATH + "/CandidateApi/creditHistory",
      requestData,
      {
        headers,
      }
    );

    if (result.success == 1) {
      const { data } = result;

      dispatch({
        type: SEND_OTP_CIBIL_SUCCESS,
        payload: result,
      });

      const msg = result.otpMsg;

      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      dispatch({
        type: SEND_OTP_CIBIL_SUCCESS,
        payload: result,
      });

      const msg = result.msg;

      toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    handleApiError(result);
  } catch (error) {
    dispatch({
      type: SEND_OTP_CIBIL_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const validateCibilOtp = (otp) => async (dispatch) => {
  try {
    dispatch({ type: VALIDATE_OTP_LOADING });

    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

    const requestData = {
      token: userLocalData.id,
      type: "VERIFY_CREDIT_OTP",
      mobile_otp: otp,
    };
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };
    const { data: result } = await axios.post(
      FOLDERPATH + "/CandidateApi/creditHistory",
      requestData,
      {
        headers,
      }
    );

    console.log(result);

    if (result.success == "1") {
      const { data } = result;

      dispatch({
        type: VALIDATE_OTP_SUCCESS,
        payload: result,
      });

      const msg = result.msg;

      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      dispatch({
        type: VALIDATE_OTP_SUCCESS,
        payload: result,
      });

      const msg = result.msg;

      toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    handleApiError(result);
  } catch (error) {
    dispatch({
      type: VALIDATE_OTP_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    handleApiError(error);
  }
};

export const saveAlternateMobile = (alt_no) => async (dispatch) => {
  try {
    dispatch({ type: SAVE_ALTERNATE_MOBILE_LOADING });

    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

    const requestData = {
      token: userLocalData.id,
      type: "VERIFY_ALTERNATE_NUMBER",
      alt_mobile_number: alt_no,
    };
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data: result } = await axios.post(
      FOLDERPATH + "/CandidateApi/creditHistory",
      requestData,
      {
        headers,
      }
    );

    if (result.success == "1") {
      const { data } = result;

      dispatch({
        type: SAVE_ALTERNATE_MOBILE_SUCCESS,
        payload: result,
      });

      const msg = result.msg;

      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      dispatch({
        type: SAVE_ALTERNATE_MOBILE_SUCCESS,
        payload: result,
      });

      const msg = result.msg;

      toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    handleApiError(result);
  } catch (error) {
    dispatch({
      type: SAVE_ALTERNATE_MOBILE_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const skipStep = (record) => async (dispatch) => {
  try {
    dispatch({ type: SAVE_SKIP_LOADING });

    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

    const requestData = {
      token: userLocalData.id,
      type: "SKIP_STEP",
    };
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data: result } = await axios.post(
      FOLDERPATH + "/CandidateApi/creditHistory",
      requestData,
      {
        headers,
      }
    );

    if (result.success == "1") {
      const { data } = result;

      dispatch({
        type: SAVE_SKIP_SUCCESS,
        payload: result,
      });

      const msg = result.msg;

      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      dispatch({
        type: SAVE_SKIP_SUCCESS,
        payload: result,
      });

      const msg = result.msg;

      toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    handleApiError(result);
  } catch (error) {
    dispatch({
      type: SAVE_SKIP_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const verifyAnswers = (record) => async (dispatch) => {
  try {
    dispatch({ type: VERIFY_ANSWERS_LOADING });

    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

    const requestData = {
      token: userLocalData.id,
      ...record,
      type: "VERIFY_ANSWERS",
    };
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data: result } = await axios.post(
      FOLDERPATH + "/CandidateApi/creditHistory",
      requestData,
      {
        headers,
      }
    );

    if (result.success == "1") {
      const { data } = result;

      dispatch({
        type: VERIFY_ANSWERS_SUCCESS,
        payload: result,
      });

      const msg = result.msg;

      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      dispatch({
        type: VERIFY_ANSWERS_SUCCESS,
        payload: result,
      });

      const msg = result.msg;

      toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }

    handleApiError(result);
  } catch (error) {
    dispatch({
      type: VERIFY_ANSWERS_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const saveCibilHistory = (record) => async (dispatch) => {
  try {
    dispatch({ type: SAVE_CIBIL_LOADING });

    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

    const requestData = {
      token: userLocalData.id,
    };
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data: result } = await axios.post(
      FOLDERPATH + "/CandidateApi/updateCreditFields",
      requestData,
      {
        headers,
      }
    );

    if (result.success == "1") {
      const { data } = result;

      dispatch({
        type: SAVE_CIBIL_SUCCESS,
        payload: result,
      });

      const msg = result.msg;

      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      dispatch({
        type: SAVE_CIBIL_SUCCESS,
        payload: result,
      });

      const msg = result.msg;

      toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }

    handleApiError(result);
  } catch (error) {
    dispatch({
      type: SAVE_CIBIL_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const deleteSaveCibilDetails = () => (dispatch) => {
  dispatch({
    type: SAVE_CIBIL_SUCCESS,
    payload: [],
  });
};

export const deleteSendOtpDetails = () => (dispatch) => {
  dispatch({
    type: SEND_OTP_CIBIL_SUCCESS,
    payload: [],
  });
};

export const deleteValidateOtpDetails = () => (dispatch) => {
  dispatch({
    type: VALIDATE_OTP_SUCCESS,
    payload: [],
  });
};

export const deleteAlternateMobileDetails = () => (dispatch) => {
  dispatch({
    type: SAVE_ALTERNATE_MOBILE_SUCCESS,
    payload: [],
  });
};

export const deleteSkipCibilDetails = () => (dispatch) => {
  dispatch({
    type: SAVE_SKIP_SUCCESS,
    payload: [],
  });
};

export const deleteVerifyAnsDetails = () => (dispatch) => {
  dispatch({
    type: VERIFY_ANSWERS_SUCCESS,
    payload: [],
  });
};
